import {TopMenu} from "../../top-menu/TopMenu";
import {Footer} from "../../footer/Footer";
import TeamWork from '../../../assets/Teamwork_original_537665.jpg';
import './Mission.css'

export const Mission = () => {
    return (
        <div className="App">
            <TopMenu/>
            <div className="main-container three-column-container">
                <div className="history-text-container">
                    <h1 className="page-title">MISSION STATEMENT</h1>
                    <h2 className="page-subtitle">As a Company</h2>
                    <p>Our mission is to provide high-quality steel shop drawings and models that meet and exceed our
                        customers' expectations. By utilizing the latest technology and adhering to strict AISC
                        standards, we ensure every project is accurate, complete, and facilitates efficient coordination
                        for our clients' success.</p>
                    <h2 className="page-subtitle">As an individual</h2>
                    <p>At Rocky Point Detailing, we are dedicated to building a special place to work, founded on professional excellence, integrity, and honesty. We commit to a positive, collaborative environment where every team member contributes to our collective goal: delivering accurate and on-time results for every project.</p>
                </div>
                <div className="two-columns-container">
                    <div className="company-image-wrapper mission-image-wrapper">
                        <img src={TeamWork}/>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}